module.exports = __webpack_public_path__ + "static/media/unknown.397db53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/unknown.png
// module id = 1872
// module chunks = 0